import React from "react"
import Styles from "./ContactForm.module.scss"

const ContactForm = () => (
  <section className={Styles.contactform}>
    <h1 className={Styles.title}>Need help? No problem we got you!</h1>

    <h4>Call Us On</h4>
    <p className={Styles.description}>012-3456-7891</p>

    <h4>Email Us</h4>
    <p className={Styles.description}>stalialondon@gmail.com</p>

    <br/>
    <h4>Email Via Contact Form</h4>
    <form
      name="contact"
      method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
    >
      <input type="hidden" name="bot-field" />
      <input type="hidden" name="form-name" value="contact" />
      <div>
        <label>
          <input type="text" name="name" placeholder="Name" />
        </label>
      </div>
      <div>
        <label>
          <input type="email" name="email" placeholder="Email" />
        </label>
      </div>
      <div>
        <label>
          <input
            type="text"
            name="contact number"
            placeholder="Contact number"
          />
        </label>
      </div>
      <div>
        <label>
          <textarea
            name="message"
            placeholder="Type your message here..."
            rows="5"
          ></textarea>
        </label>
      </div>
      <div>
        <button type="submit">Send</button>
      </div>
      <div data-netlify-recaptcha="true"></div>
    </form>
  </section>
)

export default ContactForm
